import { render, staticRenderFns } from "./DataList.vue?vue&type=template&id=937dba3e&scoped=true"
import script from "./DataList.vue?vue&type=script&lang=js"
export * from "./DataList.vue?vue&type=script&lang=js"
import style0 from "./DataList.vue?vue&type=style&index=0&id=937dba3e&prod&scoped=true&lang=css"
import style1 from "./DataList.vue?vue&type=style&index=1&id=937dba3e&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "937dba3e",
  null
  
)

export default component.exports